import {
  RugbyUnionEventDetailId,
  RugbyUnionEventStatusId,
} from '@collector/sportsapi-client-legacy'

import {
  createRugbyEventClockConfig,
  rugbyClockFixed,
  rugbyClockRunning,
  rugbyClockTiming,
  type RugbyStatusClockRule,
} from '../../configuration'

const t = rugbyClockTiming

const statusClock: Partial<
  Record<RugbyUnionEventStatusId, RugbyStatusClockRule>
> = {
  [RugbyUnionEventStatusId.NotStarted]: rugbyClockFixed(t.fromMatchStart),
  [RugbyUnionEventStatusId.FirstHalf]: rugbyClockRunning(
    t.fromMatchStart,
    t.periodLength,
  ),
  [RugbyUnionEventStatusId.Halftime]: rugbyClockFixed(t.periodLength),
  [RugbyUnionEventStatusId.FinishedRegularTime]: rugbyClockFixed(
    t.afterFirstHalf,
  ),
  [RugbyUnionEventStatusId.WaitingForExtratime]: rugbyClockFixed(
    t.afterFirstHalf,
  ),
  [RugbyUnionEventStatusId.ExtratimeHalftime]: rugbyClockFixed(
    t.afterExtraFirstHalf,
  ),
  [RugbyUnionEventStatusId.FinishedAfterExtratime]: rugbyClockFixed(
    t.afterExtraTime,
  ),
  [RugbyUnionEventStatusId.WaitingForPenalty]: rugbyClockFixed(
    t.penaltyPhaseEnd,
  ),
  [RugbyUnionEventStatusId.Penalties]: rugbyClockFixed(t.penaltyPhaseEnd),
  [RugbyUnionEventStatusId.FinishedAfterPenalties]: rugbyClockFixed(
    t.penaltyPhaseEnd,
  ),
  [RugbyUnionEventStatusId.SecondHalf]: rugbyClockRunning(
    t.periodLength,
    t.afterFirstHalf,
  ),
  [RugbyUnionEventStatusId.ExtratimeFirstHalf]: rugbyClockRunning(
    t.afterFirstHalf,
    (timing) => timing.periodLength * 2 + timing.extraPeriodLength,
  ),
  [RugbyUnionEventStatusId.ExtratimeSecondHalf]: rugbyClockRunning(
    t.afterExtraFirstHalf,
    t.afterExtraTime,
  ),
}

export const {
  getEventStatusPeriodLengthMinutes,
  getEventPeriodStartOffsetMinutes,
  getEventClockSeconds,
  isValidEventClockTime,
  getEventClockTime,
} = createRugbyEventClockConfig(statusClock)

export const extraTimeDetailId = RugbyUnionEventDetailId.FirstExtraHalfStartDate
